import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchBoxConfig } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { RoutingService } from '@spartacus/core';
import { OspCategoriesModel } from '../model';
import { OspCategoriesService } from '../services/osp-categories.service';

const DEFAULT_SEARCH_BOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 3,
  maxProducts: 5,
};

@Component({
    selector: 'app-custom-categories-details',
    templateUrl: './custom-categories-details.component.html',
    styleUrls: ['./custom-categories-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomCategoriesDetailsComponent implements OnInit, OnDestroy {
  displayOnce: boolean = false;
  @ViewChild('categoryList') categoryList: ElementRef;
  toggleAccordion(item: any) {
    item.selected = !item.selected;
  }

  toggleAllAccordion() {
    let allItemsClosed: boolean;
    const allItem = !!this.contentItemList$
      ? this.contentItemList$
      : this.filteredContents$;
    allItem?.forEach((category) => {
      allItemsClosed = category?.contentItems.every((item) => !item.selected);
    });

    allItem?.forEach((category) => {
      category?.contentItems.forEach(
        (item) => (item.selected = allItemsClosed)
      );
    });
  }

  toggleClosedAccordion() {
    let allItemsClosed: boolean = true;
    const allItem = !!this.contentItemList$
      ? this.contentItemList$
      : this.filteredContents$;

    allItem?.forEach((category) => {
      category?.contentItems.forEach(
        (item) => (item.selected = allItemsClosed)
      );
    });
    setTimeout((_) => {
      this.changeDetectorRef.detectChanges();
      window.location.reload();
    }, 100);
  }
  searchQuery: string = '';
  contentCategoryCode: string;
  contentItemCode: string;
  urlItem$: Observable<any>;
  filteredContents$: Observable<OspCategoriesModel>;
  allContentCategories$: Observable<OspCategoriesModel>;
  toggleAllItems: boolean;
  active: boolean = false;
  setActive: boolean = false;
  public contentItemList$: Observable<OspCategoriesModel>;
  getCodeFromParams$: Observable<any>;
  routeSub: Subscription;
  codeParamsSub: Subscription;
  constructor(
    private readonly router: Router,
    private readonly ospService: OspCategoriesService,
    private readonly route: ActivatedRoute,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    private readonly routerUrl: RoutingService
  ) {
    this.urlItem$ = this.route.queryParams;

    this.getCodeFromParams$ = combineLatest([
      this.route.params,
      this.route.queryParams,
    ]).pipe(
      map(([params, queryParams]) => {
        return {
          contentCategoryCode:
            params.contentCategoryCode !== undefined
              ? params.contentCategoryCode
              : '',
          contentItemCode: queryParams.item,
        };
      })
    );
  }

  performSearch() {
    if (this.searchQuery) {
      this.router.navigate(['/search', this.searchQuery]);
    }
  }

  selectedCategory: any = null;

  showCategoryAccordion(category: any, event) {
    this.selectedCategory = category;
    if (event) {
      this.categoryList.nativeElement.querySelectorAll('a').forEach((elem) => {
        elem?.classList.remove('active');
      });

      event.target.classList.add('active');
      this.setActive = false;
    }
    window.scrollTo(0, 0);
  }
  setActiveLeftCategory(category) {
    this.routeSub = this.route.params.subscribe((paramsId) => {
      if (paramsId?.contentCategoryCode === category?.code) {
        this.setActive = true;
      } else {
        this.setActive = false;
      }
    });
    return this.setActive;
  }

  showAllCategories() {
    this.selectedCategory = null;
  }

  redirectToHelpCenter() {
    this.router.navigateByUrl('/help-center/all');
    window.scrollTo(0, 0);
    setTimeout((_) => {
      this.changeDetectorRef.detectChanges();
      window.location.reload();
    }, 100);
  }

  ngOnInit(): void {
    this.codeParamsSub = this.getCodeFromParams$
      .pipe(
        map((paramsData) => paramsData),
        switchMap((paramsData) => {
          return this.ospService.getContentItems(
            paramsData.contentCategoryCode,
            paramsData.contentItemCode
          );
        })
      )
      .subscribe((res) => {
        this.allContentCategories$ = res?.allSubcategories;
        this.urlItem$.subscribe((param) => {
          if (param.hasOwnProperty('item')) {
            this.filteredContents$ = res?.allSubcategories.filter(
              (category) => {
                return category.contentItems.some((item) =>
                  item?.code.includes(param?.item)
                );
              }
            );
          } else {
            this.route.params.subscribe((paramsId) => {
              if (paramsId?.contentCategoryCode === 'all') {
                this.contentItemList$ = res?.allSubcategories;
              } else {
                this.contentItemList$ = res?.allSubcategories.filter(
                  (category) => {
                    return category.selected === true;
                  }
                );
              }
            });
          }
        });
        this.categoryList.nativeElement
          .querySelectorAll('categoryLinks')
          .forEach((elem) => {
            elem?.classList.remove('active');
          });
        setTimeout((_) => {
          this.changeDetectorRef.detectChanges();
        }, 10);
      });
  }
  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.codeParamsSub?.unsubscribe();
  }
  showHeading(documents) {
    let isShown: boolean = false;
    if (isShown) return;
    if (documents) {
      documents.forEach((el) => {
        if (
          el?.type === 'PDF' ||
          el?.type === 'YOUTUBE_VIDEO' ||
          el?.type === 'VIDEO'
        ) {
          isShown = true;
        } else {
          isShown = false;
        }
      });
    }
    return isShown;
  }
}
